import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    layoutNavVisible: false,
    tycosVisible: false,
    avisoVisible: false,
    cookiesVisible: false,
    modalVisible: false
  },
  mutations: {
    closeLayoutNav(state) {
      state.layoutNavVisible = false;
    },
    toggleLayoutNav(state) {
      state.layoutNavVisible = !state.layoutNavVisible;
    },
    closeTycos(state) {
      state.tycosVisible = false;
    },
    closeAviso(state) {
      state.avisoVisible = false;
    },
    closeCookies(state) {
      state.cookiesVisible = false;
    },
    closeModal(state) {
      state.modalVisible = false;
    },
    toggleTycos(state) {
      state.tycosVisible = !state.tycosVisible;
    },
    toggleAviso(state) {
      state.avisoVisible = !state.avisoVisible;
    },
    toggleCookies(state){
      state.cookiesVisible = !state.cookiesVisible;
    },
    toggleModal(state){
      state.modalVisible = !state.modalVisible;
    }

  },
  actions: {},
  modules: {},
});
